import PackItem from './PackItem'

export default PackItem



// WEBPACK FOOTER //
// ./src/containers/Modals/PackItem/index.js